import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import MusicForm from './MusicForm';

function EditMusic() {
  const { id } = useParams();
  const [form, setForm] = useState({ music_name: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchMusic = async () => {
      const res = await fetch(`/api/music/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setForm({ music_name: data.music_name });
      }
    };
    fetchMusic();
  }, [id, token]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async () => {
    setIsSubmitting(true);

    const res = await fetch(`/api/music/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(form)
    });

    if (res.ok) {
      alert('Music updated!');
    } else {
      const data = await res.json();
      alert(data.message || 'Error updating music');
    }

    setIsSubmitting(false);
  };

  return <MusicForm form={form} onChange={handleChange} onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
}

export default EditMusic;
